"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-de03a278-37d7-4a44-b1a6-b23f43500e2c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.71 453.32",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M345.58,323.18l-39.56-21.71-17.2,6.53,40.36,22.15-147.95,107.5L34.46,329.37l39.58-21.7-17.21-6.53-38.7,21.22c-2.09,1.15-3.46,3.29-3.62,5.67-.16,2.38,.91,4.68,2.83,6.1l159.7,117.82c1.23,.91,2.69,1.37,4.16,1.37s2.89-.45,4.11-1.34l161.02-117c1.94-1.41,3.02-3.71,2.87-6.11s-1.52-4.54-3.62-5.69Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "277.21 285.66 195.03 240.56 195.03 256.53 260.01 292.19 277.21 285.66",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "168.67 239.83 85.66 285.34 102.87 291.87 168.67 255.8 168.67 239.83",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M174.85,320.11c0,3.87,3.13,7,7,7s7-3.13,7-7v-13.53h-14v13.53Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M82.37,76.08h24.36v78.23c0,2.51,1.35,4.83,3.53,6.08l64.59,36.92v113.97h14v-113.97l64.59-36.92c2.18-1.25,3.53-3.57,3.53-6.08V76.08h24.36c12.47,0,22.62-10.15,22.62-22.62V7c0-3.87-3.13-7-7-7s-7,3.13-7,7V53.46c0,4.75-3.87,8.62-8.62,8.62h-38.36v88.17l-61.12,34.93-61.12-34.93V76.08h72.11c3.75-.14,6.76-3.21,6.76-7s-3.01-6.86-6.76-6.99H82.37c-4.75-.01-8.62-3.88-8.62-8.63V7c0-3.87-3.13-7-7-7s-7,3.13-7,7V53.46c0,12.47,10.15,22.62,22.62,22.62Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M363.25,266.38c-1.37-3.61-5.41-5.43-9.03-4.06l-70.67,26.81-17.2,6.53-51.21,19.43c-3.61,1.37-5.43,5.41-4.06,9.03,1.06,2.8,3.72,4.52,6.55,4.52,.83,0,1.67-.15,2.48-.46l62.38-23.67,17.2-6.53,59.5-22.58c3.61-1.37,5.43-5.41,4.06-9.03Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M198.98,342.72c-1.42,3.6,.35,7.66,3.94,9.08l45.92,18.12c.84,.33,1.71,.49,2.57,.49,2.79,0,5.43-1.68,6.51-4.43,1.42-3.6-.35-7.66-3.94-9.08l-45.92-18.12c-3.6-1.42-7.66,.35-9.08,3.94Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M80.38,304.2l63.23,23.99c.82,.31,1.66,.46,2.48,.46,2.82,0,5.48-1.72,6.55-4.52,1.37-3.62-.45-7.66-4.06-9.03l-52.05-19.75-17.21-6.53-69.83-26.49c-3.61-1.37-7.66,.45-9.03,4.06-1.37,3.62,.45,7.66,4.06,9.03l58.65,22.25,17.21,6.53Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M105.78,365.98c1.09,2.75,3.72,4.43,6.51,4.43,.85,0,1.72-.16,2.57-.49l45.92-18.12c3.6-1.42,5.36-5.48,3.94-9.08s-5.49-5.36-9.08-3.94l-45.92,18.12c-3.6,1.42-5.36,5.48-3.94,9.08Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;